require('script-loader!.tmp/js/templates/location/modules/LocationInfo.js');

class CurrentlyOperatingServices {
    static async currentServices() {
        const currentServicesWrapper = document.getElementById("LocationInfo-operating")

        if (!currentServicesWrapper) return;

        const corporateCode = currentServicesWrapper.dataset.corporatecode;

        const query = `https://liveapi.yext.com/v2/accounts/7244068133347258491/entities/${corporateCode}?api_key=ef2fb20c38fa1aaef7446f483c924b27&v=20200808&fields=googleAttributes`;

        const response = await fetch(query);
        const responseBody = await response.json();

        if (responseBody && responseBody.response && responseBody.response.googleAttributes) {
            const googleAttributes = responseBody.response.googleAttributes;

            const possibleValues = {
            "Dinein": googleAttributes.serves_dine_in ? googleAttributes.serves_dine_in[0] == 'true' ? true : false : false,
            "Curbside": googleAttributes.has_curbside_pickup ? googleAttributes.has_curbside_pickup[0] == 'true' ? true : false : false,
            "Carryout": googleAttributes.has_takeout ? googleAttributes.has_takeout[0] == 'true' ? true : false : false,
            "Delivery": googleAttributes.has_delivery ? googleAttributes.has_delivery[0] == 'true' ? true : false : false,
            "Drivethru": googleAttributes.has_drive_through ? googleAttributes.has_drive_through[0] == 'true' ? true : false : false,
            "baseUrl": `${Yext.BaseUrl}`,
            "siteInternalHostName": `${Yext.SiteInternalHostName}`,
            "locale": `${Yext.locale}`
            };

            currentServicesWrapper.innerHTML = location.CurrentlyOperating(possibleValues);
        }
    }
}

export { CurrentlyOperatingServices }
